import useAutoLaunch from './useAutoLaunch';

export default useAutoLaunch;
